import SrNumber from "./SrNumber.vue";

SrNumber.install = function(Vue) {
  Vue.component(SrNumber.name, SrNumber);
};

export default SrNumber;



// WEBPACK FOOTER //
// ./packages/SrNumber/index.js